export default __webpack_public_path__ + "static/media/agustin_baragiola.b8ee1d11.jpeg";